module.exports = "Bin ID,Farm Name,Capacity\n"